import { render, staticRenderFns } from "./AppointmentSummary.vue?vue&type=template&id=fa81b628&"
import script from "./AppointmentSummary.vue?vue&type=script&lang=js&"
export * from "./AppointmentSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports